module.exports = __webpack_public_path__ + "static/Berber Block 01-2bc8ea6433a4406a7e26a7156cd6302c.png";